import { memo } from 'react';

type Props = {
  top: number;
  left: number;
  title: string;
  subtitle: string;
  onSelect: () => void;
};

export const MentionMenu = memo(
  ({ top, left, title, subtitle, onSelect }: Props) => (
    <div
      className="absolute z-10 min-w-[220px] rounded-lg border border-[#E2E8F0] bg-white px-3 py-2 shadow-[0_12px_24px_rgba(0,0,0,0.18)]"
      style={{ top, left }}
      role="listbox"
      aria-label="mention options"
    >
      <button
        type="button"
        className="flex cursor-pointer flex-col items-start gap-1 p-0 text-left"
        onMouseDown={(event) => event.preventDefault()}
        onClick={onSelect}
      >
        <span className="text-base font-medium leading-6 text-[#5F1ECC]">
          {title}
        </span>
        <span className="text-sm font-normal leading-5 text-[#9E9E9E]">
          {subtitle}
        </span>
      </button>
    </div>
  ),
);

MentionMenu.displayName = 'MentionMenu';
